import { createUseStyles } from "react-jss";

const FinancialStyles = createUseStyles({
    detailWrapper: {
      padding: "15px",
    },
    detailItem: {
      display: "inline-block",
      paddingRight: "62px",
    },
    smallText: {
      display: "block",
      paddingBottom: 4,
      fontSize: "14px",
      textAlign: "center",
    },
    detail: {
      textAlign: "center",
      "& h5": {
        fontSize: "18px",
      },
    },
    statusButton: {
      border: "1px solid #1d5f02",
      color: "#1d5f02",
      background: "#fff",
      fontSize: "11px",
      padding: "4px 10px 3px",
      borderRadius: "2px",
    },
    lightGreen: {
      color: "#2a8703",
    },
    financialTabNavigation: {
      "& nav > ul > li > a": {
        background: "none",
      }
    },
    star: {
      marginRight: "24px",
      height: "24px",
      width: "24px"
    },
    starFilled: {
      marginRight: "14px",
      height: "44px",
      width: "44px"
    },
    icon: {
      cursor: "pointer",
    },
    financialActionButtons: {
      justifyContent: "flex-end",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      height: "100%",
    },
    financialWrapper: {
      background: "#F5F5F5",
      width: "100%",
      padding: "25px 30px",
    },
    header: {
      paddingLeft: 16,
      paddingBottom: 16,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "end",
    }, 
    pageTitle: {
      fontSize: 36,
    },
    create: {
      paddingRight: 20,
    }
  });

  export default FinancialStyles;